import Container from '@oneflare/flarekit/lib/components/Container';
import type { PropsWithChildren } from 'react';
import { memo } from 'react';

import {
  BusinessRegistrationStyled,
  BusinessRegistrationWrapperStyled
} from './styled/CTASection';

interface ICtaSection {
  className?: string;
}

const CTASection = ({
  className = '',
  children
}: PropsWithChildren<ICtaSection>) => {
  return (
    <BusinessRegistrationWrapperStyled className={className}>
      <Container>
        <BusinessRegistrationStyled>
          {children}
        </BusinessRegistrationStyled>
      </Container>
    </BusinessRegistrationWrapperStyled>
  );
};

export default memo(CTASection);
